import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UpdateAlertMutation,
  UpdateAlertMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { usePerformMutation } from "src/graphql/utils";

export const updateAlertMutation = gql(/* GraphQL */ `
  mutation UpdateAlert($id: ID!, $comment: String!) {
    updateAlert(id: $id, options: { comment: $comment }) {
      ...AlertFragment
    }
  }
`) as TypedDocumentNode<UpdateAlertMutation, UpdateAlertMutationVariables>;

export const useUpdateAlertMutation = ({ onSuccess }) =>
  usePerformMutation(updateAlertMutation, { onSuccess });
